/* eslint-disable import/prefer-default-export */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/// <reference types="facebook-pixel" />
import { requestUUID } from './helpers'

const pageDetails = (): facebook.Pixel.ViewContentParameters => {
  const el: HTMLElement = document.querySelector('#page-track-data')
  if (!el) return
  const { productSkus } = el.dataset
  const content_ids = productSkus.split(',')
  return {
    content_ids,
    content_type: 'product',
  }
}

export async function trackPageView(): Promise<void> {
  if (typeof fbq !== 'undefined') {
    const parameters = pageDetails()
    if (!parameters) return
    const eventID = requestUUID()
    fbq('track', 'ViewContent', parameters, { eventID })
  }
}
